import React, { useState, useEffect } from 'react'
import "./CustomDatatableSuiviTransmission.css";
import { FaPencilAlt, FaRegCommentDots } from "react-icons/fa";
import { HiEye } from "react-icons/hi";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import Pagination from '../Pagination/Pagination';
import { customFormatDate, customFormatHour } from '../../utils/utils';



const CustomDatatableSuiviTransmission = (props) => {

    const { columns, 
        data, 
        changePage, 
        pageCount, 
        pageNumber, 
        perPage, } = props;
    let months= ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

    
    const navigate = useNavigate();

    return (
        <>
        {/* Start */}
        <div className="table-responsive ">
            <table className="table table-striped dataTable w-100">
                <thead className="">
                    <tr className="" role={"row"}>
                        {columns && columns.map((item, index) =>
                            <th key={index+"wcdstrc"} className={item.label == "#" ? "text-left pl-4" :"text-left pl-3"} aria-sort="ascending" >
                                {item.label}</th>
                        )}
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length != 0 ? data?.map((item, index) =>
                        <tr key={index+"wcdstrd"}>
                            
                            <td className="text-left pl-4">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                            <td className="text-left pl-3">
                                            {months[parseInt(item.mois) - 1]}
                                        </td>
                                        <td className="text-left pl-3">
                                            {/* {Date(item.created_at)} */}
                                            {item.annee}
                                        </td>
                                        <td className="text-left pl-3">
                                            {/* {months[parseInt(item.mois)]}{" "}{item.annee} */}
                                            {customFormatDate(item.created_at)}{" à "}{ customFormatHour(item.created_at)}

                                        </td>
                                        <td className="text-left pl-3">
                                         <span className={item.statut == "Transmis" ? "badge badge-success": item.statut == "Transmis en retard" ? "badge badge-warning" : "badge badge-danger" }>{item.statut}</span>
                                        </td>
                                        <td className="text-left pl-3">
                                            {item.institution?.libelle}
                                        </td>
                           
                           
                            <td className=" text-center">
                                <HiEye onClick={() => navigate(`/suivi-transmission/${item.id}`)} title="Visualiser" style={{ fill: "#0E1726", height: 20, width: 25, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                                <FaRegCommentDots 
                                onClick={() => navigate(`/transmission-chat/${item.id}`)} 
                                title="Commenter" style={{ fill: "#2196F3", height: 25, width: 30, padding: 2, cursor: "pointer" }} className="custom-edit-button mr-1" />
                            </td>
                            {/* <button title="Consulter" className="btn btn-success btn-sm mr-1" onClick={() => handleShowEditTransmission(item.id)}> <HiEye /> </button> */}
                        </tr>
                    ) : <h1 className="ok"></h1>}
                </tbody>
            </table>
            <Pagination pageCount={pageCount} changePage={changePage} />
        </div>
        {/* End */}
  
        </>
    )
}

export default CustomDatatableSuiviTransmission